export default "__VITE_PUBLIC_ASSET__ff825b89__"